export default {
  NO_PURCHASE: 'no_purchase',
  ONGOING_ONBOARDING: 'ongoing_onboarding',
  NOT_ELIGIBLE: 'not_eligible',
}